import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import {Observable} from 'rxjs/index';

@Injectable()
export class NoauthGuard implements CanActivate {

  public isAuthentificated: boolean;

  constructor(
    public authService: AuthenticationService,
    public router: Router
  ) {
    this.isAuthentificated  = false;
    this.authService.isAuthenticated.subscribe((value: boolean) => {
      this.isAuthentificated = value;
    });
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      if (this.isAuthentificated) {
        this.router.navigate(['']);
        return false;
      }
      return true;
  }
}
